<template id="report">
  <div>
    <ReportItem label="0,10€" :item="report.reportp010" vvFormScope="reportp010"></ReportItem>
    <ReportItem label="0,20€" :item="report.reportp020" vvFormScope="reportp020"></ReportItem>
    <ReportItem label="0,50€" :item="report.reportp050" vvFormScope="reportp050"></ReportItem>
  </div>
</template>
<script>
import ReportItem from './ReportTemplate1Item.vue'
export default {
  inject: ["$validator"],
  name: "report-component",
  template: "#report",
  props: {
    report: {
      type: Object
    },
    vvFormScope: {
      type: String
    }
  },
  filters: {
    ToUppercase: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    }
  },
  components: {
      ReportItem
  }
};
</script>